type AppMetadata = {
  appName: string
  appVersion: string
}

type AppMetadataInput = {
  appName?: string
  appVersion?: string
}

export const resolveAppMetadata = ({
  appName,
  appVersion,
}: AppMetadataInput): AppMetadata => ({
  appName: appName ?? 'webapp',
  appVersion: appVersion ?? 'dev',
})

export const APP_METADATA = resolveAppMetadata({
  appName: import.meta.env.VITE_APP_NAME,
  appVersion: import.meta.env.VITE_APP_VERSION,
})
